import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatToolbarModule } from '@angular/material/toolbar';
import { FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TextMaskModule } from 'angular2-text-mask';
import { SharedModule } from '../../../../../../shared/shared.module';
import { HistoryFormComponent } from './history.component';
import { MatDialogModule } from '@angular/material/dialog';
import { ListGridModule } from '../../../../../../shared/listGrid/listGrid.module';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    FlexLayoutModule,
    TextMaskModule,
    SharedModule,
    MatDialogModule,
    MatToolbarModule,
    MatIconModule,
    ListGridModule,
  ],
  declarations: [HistoryFormComponent],
  entryComponents: [],
  exports: [HistoryFormComponent],
  providers: [],
})
export class HistoryFormModule {}
